import React from 'react';
import { resolveImageUrl } from '../../../utils/imageUrl.js';
import productDefaultImg from '../../../assets/product-default.png';
import serviceDefaultImg from '../../../assets/service-default.png';

const defaultImageFor = (item) =>
  String(item?.type || '').toLowerCase() === 'service' ? serviceDefaultImg : productDefaultImg;

export default function ItemGrid({
  room,
  items = [],
  onBack,
  onItemClick,
  itemSelectionMode = false,
  selectedItemIds = [],
  onToggleItemSelect,
}) {
  return (
    <div className="library-item-grid">
      <button className="library-back-btn" onClick={onBack}>
        {'<- Back'}
      </button>

      <h3>{room.name}</h3>

      <div className="library-grid">
        {items.length === 0 ? (
          <div className="library-empty-state">
            <div className="library-empty-icon" aria-hidden="true">
              [ ]
            </div>
            <div className="library-empty-title">No items in this section yet</div>
            <div className="library-empty-sub">Add items from your catalog or move items here.</div>
            <button type="button" className="library-add-button" onClick={onBack}>
              Back to Sections
            </button>
          </div>
        ) : (
          items.map((item) => {
            const itemId = item.sk || item.itemId;
            const isSelected = selectedItemIds.includes(itemId);

            return (
              <div
                key={itemId}
                className={`library-item-card clickable ${isSelected ? 'selected' : ''}`}
                onClick={() => {
                  if (itemSelectionMode) {
                    onToggleItemSelect?.(itemId);
                    return;
                  }
                  onItemClick(item);
                }}
              >
                {itemSelectionMode && (
                  <div
                    className={`room-select-circle ${isSelected ? 'checked' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onToggleItemSelect?.(itemId);
                    }}
                  >
                    <div className="inner" />
                  </div>
                )}

                <img src={resolveImageUrl(item, defaultImageFor(item))} alt={item.name} />

                <div className="library-overlay">
                  <h4>{item.name}</h4>
                  <span>
                    ${(item.clientUnit ?? item.pricePerUnit ?? item.tradePrice ?? 0).toFixed(2)}
                    /unit
                  </span>
                  <p>{item.description}</p>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
